const initialState = {
	isLoading: 0,
	hasError: 0
};

export default (state = initialState, action) => {
	switch (action.type) {
		case "TRAINING_ARE_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "TRAINING_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				hasError: 1,
				error: action.error
			};
		case "TRAINING_SUCCESS":
			return {
				...state,
				training: action.data.data,
				isLoading: 0
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/training.js